import { ADD_QTI_IMPORTS, CLEAR_QTI_IMPORTS } from '@instructure/quiz-common';
export function addQtiImports(imports) {
  return {
    type: ADD_QTI_IMPORTS,
    payload: imports
  };
}
export function clearQtiImports() {
  return {
    type: CLEAR_QTI_IMPORTS
  };
}